'use client'

import * as React from 'react'
import { Slider as SliderPrimitive } from 'radix-ui'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

const sliderVariants = cva(
  [
    '[--slider-color:var(--color-green-darker)]',
    '[--slider-thumb-color:var(--color-green-lighter)]',
    '[--slider-track-color:var(--color-smoke)]',
  ].join(' '),
  {
    variants: {
      variant: {
        default: '',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

function Slider({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root> & VariantProps<typeof sliderVariants>) {
  return (
    <SliderPrimitive.Root
      data-slot="slider"
      className={cn('relative flex w-full touch-none select-none items-center', sliderVariants({ variant }), className)}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-(--slider-track-color)">
        <SliderPrimitive.Range data-slot="slider-range" className="absolute h-full bg-(--slider-color)" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        data-slot="slider-thumb"
        className={cn(
          'cursor-grab block size-3 rounded-full bg-(--slider-thumb-color) transition-shadow',
          'shadow-[inset_0_0_0_3px_white,0_0_0_2px_var(--slider-color)]',
          'focus-visible:outline-none',
          'disabled:pointer-events-none disabled:opacity-50'
        )}
      />
    </SliderPrimitive.Root>
  )
}

export { Slider, sliderVariants }
